<section>
  <div
    class="bg-hero-pattern bg-no-repeat bg-center bg-cover pt-[152px] pb-[80px] md:pt-[204px] md:pb-[140px]"
  >
    <div class="flex justify-center">
      <div
        class="max-md:px-[16px] w-full max-w-[705px] flex flex-col gap-10"
      >
        <div class="text-white text-center bg-center flex flex-col gap-2">
          <div
            class="whitespace-pre-line text-h3 md:text-h1 leading-[1.2] font-medium"
          >
            {{ heroSection.title }}
          </div>
          <div class="text-b1 md:text-h5">{{ heroSection.subTitle }}</div>
        </div>
        <div class="flex flex-col gap-6">
          <div
            class="bg-transparent md:bg-white md:rounded-[12px] verflow-hidden flex flex-col gap-4 md:gap-[30px] md:flex-row md:justify-between"
          >
            <input
              [(ngModel)]="searchInput"
              type="text"
              class="py-[10px] px-[10px] md:pl-[40px] rounded-[10px] placeholder:text-G500 placeholder:text-b1 outline-none w-full placeholder:line-clamp-1"
              placeholder="{{ heroSection.searchPlaceholder }}"
              (keydown.enter)="submitSearchQuery()"
            />
            <div (click)="submitSearchQuery()">
              <basic-button
                [type]="2"
                [title]="heroSection.buttonText1"
                [extraClass]="'max-md:min-w-full text-center'"
              />
            </div>
          </div>
          <div class="flex flex-wrap justify-center items-center gap-2">
            <div
              *ngFor="let provider of providerTypes"
              (click)="clickProviderTypeTag(provider.title)"
            >
              <basic-tag [type]="1" [title]="provider.title" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
